/**
 * Builds the ws-scrcpy "Live view" URL for a box, or null if not configured.
 *
 * Set VITE_SCRCPY_URL to your agent host's ws-scrcpy address. Include `{ip}`
 * to deep-link straight into a device's stream, e.g.:
 *   http://10.106.177.55:8000/#!action=stream&udid={ip}:5555&player=webcodecs
 * Without `{ip}` it just opens ws-scrcpy's device list.
 *
 * The stream runs browser -> agent over the LAN; this only produces the link.
 */
export function scrcpyUrl(ip: string): string | null {
  const template = import.meta.env.VITE_SCRCPY_URL as string | undefined;
  if (!template) return null;
  return template.includes('{ip}') ? template.replace(/\{ip\}/g, ip) : template;
}
